import { AnimatedSkeletonBlock } from "@redotech/redo-web/skeleton";
import { lazy, memo, type ReactNode, Suspense } from "react";
import {
  HOME_SOURCES,
  type HomeRecordType,
  type RecordHomeSource,
} from "../sources/record-home-source";
import { RecordHomeErrorBoundary } from "./record-home-error-boundary";
import { useRecordHomeExperience } from "./use-record-home-experience";

const LazyRecordHomePage = lazy(() =>
  import("../record-home-page").then((module) => ({
    default: module.RecordHomePage,
  })),
);

/** The only place that chooses between a type's table and its home page. */
export const RecordHomeExperienceGate = memo(function RecordHomeExperienceGate({
  type,
  legacy,
}: {
  type: HomeRecordType;
  legacy: ReactNode;
}) {
  const { useNewUi } = useRecordHomeExperience(type);
  if (!useNewUi) {
    return legacy;
  }
  const sources: RecordHomeSource[] = [HOME_SOURCES[type]].filter(
    (source): source is RecordHomeSource => source !== undefined,
  );
  return (
    <RecordHomeErrorBoundary fallback={legacy}>
      <Suspense fallback={<AnimatedSkeletonBlock height="100%" width="100%" />}>
        <LazyRecordHomePage sources={sources} />
      </Suspense>
    </RecordHomeErrorBoundary>
  );
});
